import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { tv } from "tailwind-variants";
import cn from "../../utils/cn";
import Typography from "../Typography/Typography";
const tooltipVariants = tv({
    variants: {
        size: {
            sm: "max-w-36",
            md: "max-w-48",
            lg: "max-w-60",
        },
    },
});
const Tooltip = forwardRef(function Tooltip({ children, content, asChild, open, defaultOpen, align = "center", position = "top", className, portal = true, enable = true, arrow = true, size = "md", onOpenChange, ...props }, ref) {
    const tooltipContent = typeof content === "string" ? (_jsx(Typography, { variant: "caption-medium", color: "white", className: tooltipVariants({ size }), children: content })) : (content);
    // Content testing a number of characters to determine the size of the tooltip
    const WrapperPortal = portal ? TooltipPrimitive.Portal : React.Fragment;
    if (enable) {
        return (_jsxs(TooltipPrimitive.Root, { open: open, defaultOpen: defaultOpen, onOpenChange: onOpenChange, children: [_jsx(TooltipPrimitive.Trigger, { type: "button", asChild: asChild, ref: ref, children: children }), _jsx(WrapperPortal, { children: _jsxs(TooltipPrimitive.Content, { sideOffset: 5, alignOffset: -10, side: position, align: align, className: cn("z-tooltip rounded-md bg-gray-black px-2 py-1 text-white shadow-md will-change-[transform,opacity] data-[side=bottom]:animate-slide-up-and-fade data-[side=left]:animate-slide-right-and-fade data-[side=right]:animate-slide-left-and-fade data-[side=top]:animate-slide-down-and-fade ", className), ...props, children: [tooltipContent, arrow && _jsx(TooltipPrimitive.Arrow, { className: cn("text-gray-black"), width: 12, height: 6, startOffset: 10 })] }) })] }));
    }
    return children;
});
export default Tooltip;
